import React from 'react';
import { QuoteIcon } from 'lucide-react';
interface TestimonialCardProps {
  text: string;
  highlight?: boolean;
  profileImage?: string;
  name?: string;
}
export function TestimonialCard({
  text,
  highlight = false,
  profileImage,
  name = 'Peptide Science Institute Transformation Client'
}: TestimonialCardProps) {
  return <div className={`relative ${highlight ? 'bg-gradient-to-r from-purple-900/40 to-cyan-900/40 border-2 border-cyan-500/50' : 'bg-slate-900/30 border border-purple-500/20'} rounded-lg p-6 md:p-8`} data-id="element-226">
      <div className={`flex ${profileImage ? 'flex-col md:flex-row gap-6 md:gap-8' : ''}`} data-id="element-227">
        {profileImage && <div className="flex-shrink-0" data-id="element-228">
            <img src={profileImage} alt="Client" className="w-24 h-24 md:w-32 md:h-32 rounded-full object-cover border-4 border-cyan-500/50 shadow-lg shadow-cyan-500/30" data-id="element-229" />
          </div>}
        <div className="flex-1" data-id="element-230">
          <QuoteIcon className="w-8 h-8 text-cyan-400/50 mb-4" data-id="element-231" />
          <p className={`text-lg ${highlight ? 'text-white' : 'text-gray-300'} italic leading-relaxed font-light`} data-id="element-232">
            "{text}"
          </p>
          <p className="text-sm text-cyan-400 mt-4 font-medium" data-id="element-233">— {name}</p>
        </div>
      </div>
    </div>;
}